export const enum AppErrorType {
  BAD_CONFIGURATION = 'BAD_CONFIGURATION',
  GENERIC_ERROR = 'GENERIC_ERROR',
  RELOAD_PAGE = 'RELOAD_PAGE',
}

export type AppErrorCtaCallback = () => void

export type AppError = {
  error?: string | Error
  errorType?: AppErrorType
  errorMessage?: string
  ctaCallback?: AppErrorCtaCallback
}
